<template>
    <NuxtLink
        :to="fullSlug"
        class="group relative inline-block w-full grid-cols-12 items-center bg-white py-3 sm:grid md:px-20">
        <div class="col-span-6 flex space-x-5 md:col-span-4">
            <picture
                class="max-h-10 max-w-10 shrink-0 self-center rounded-8 border border-[#c2c2c2] object-contain">
                <source
                    v-if="imageSrc.webp"
                    type="image/webp"
                    :srcset="getMediaLink(imageSrc.webp) || ''" />
                <source
                    v-else-if="!imageSrc.webp && !imageSrc.png"
                    srcset="/assets/images/ui/placeholder/webp/cromi.webp"
                    type="image/webp" />
                <img
                    width="40"
                    height="40"
                    :alt="image?.alt || item.name"
                    :src="
                        getMediaLink(imageSrc.png) ||
                        '/assets/images/ui/placeholder/jpg-png/cromi.png'
                    "
                    class="max-h-10 max-w-10 shrink-0 self-center rounded-8 border border-[#c2c2c2] object-contain" />
            </picture>
            <div class="max-sm:space-y-1">
                <p class="text-12/140 font-medium text-ash">
                    {{ item.type_title }}
                </p>
                <p
                    class="line-clamp-1 text-16/150 font-semibold text-ash transition-colors duration-300 group-hover:text-accent">
                    {{ item.name }}
                </p>
            </div>
        </div>

        <p
            v-if="item.cost"
            class="col-span-4 text-center text-16/150 font-medium text-ash max-sm:absolute max-sm:right-0 max-sm:top-0 max-sm:w-fit max-sm:text-12/140 max-sm:text-ash-300 md:col-span-7">
            цена: от <span class="font-semibold">{{ item.cost }}</span> ₽
        </p>

        <AtomIcon
            name="arrow-right"
            width="20"
            height="20"
            class="-col-end-1 text-right text-ash transition-colors duration-300 group-hover:text-accent max-sm:hidden" />
    </NuxtLink>
</template>

<script lang="ts" setup>
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'
import {
    type ProductSearch,
    SEARCH_ITEM_TYPE,
} from '~/components/modals/search-modal/search-modal.types'

const props = defineProps({
    item: {
        type: Object as PropType<ProductSearch>,
        required: true,
    },
})
const image = computed(() => {
    if (!props.item.image) return null

    return Array.isArray(props.item.image)
        ? props.item.image[0] || null
        : props.item.image
})
const imageSrc = computed(() => {
    return {
        webp: image.value?.webp_url || '',
        png: image.value?.url || '',
    }
})
const fullSlug = computed(() => {
    if (props.item.type_name == SEARCH_ITEM_TYPE.PRODUCT) {
        return `/catalog/${props.item.slug}`
    } else if (props.item.type_name == SEARCH_ITEM_TYPE.MODEL_RANGE) {
        return `/${props.item.parent_slug}/${props.item.slug}`
    } else if (props.item.type_name == SEARCH_ITEM_TYPE.DIRECTIONS) {
        return `/${props.item.slug}`
    }

    return ''
})
</script>
